import { HttpClient, setMap } from 'Mri.Web.Common';
import { action, observable } from 'mobx';

export interface Alert {
    contractAlertKey?: number;
    daysFromExpiration?: number;
    hourOfDay?: number;
    minuteOfDay?: number;
    internalOnly?: boolean;
}

export class AlertStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadAlertsAsync(): Promise<void> {
        const response = await this.httpClient.get<Alert[]>('/api/v1/contracts/expiration-alerts');
        setMap(this.alerts, response, x => x.contractAlertKey);
    }

    @action
    public async createAlertAsync(alert: Alert): Promise<void> {
        const response = await this.httpClient.put<Alert>('/api/v1/contracts/expiration-alerts', alert);
        if (response?.contractAlertKey) this.alerts.set(response.contractAlertKey, response);
    }

    @action
    public async updateAlertAsync(alert: Alert): Promise<void> {
        const response = await this.httpClient.post<Alert>(
            `/api/v1/contracts/expiration-alerts/${alert.contractAlertKey}`,
            alert
        );
        if (response?.contractAlertKey) this.alerts.set(response.contractAlertKey, response);
    }

    @action
    public async deleteAlertAsync(contractAlertKey: number): Promise<void> {
        await this.httpClient.delete(`/api/v1/contracts/expiration-alerts/${contractAlertKey}`);
        this.alerts.delete(contractAlertKey);
    }

    @observable public alerts = new Map<number, Alert>();
    private readonly httpClient: HttpClient;
}
